import { useEffect } from "react";
import { Box } from "@mui/material";
import { SectionWrapper, TitleWrapper } from "../../../styles/sectionStyles";
import { Certification } from "./Certification";
import Certifications from "../../../data/Certifications.json";

// imgs:
import HCMUELogo from "../../../assets/Logo_HCMUE.png";

export const CertificationsContainer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <SectionWrapper>
      <TitleWrapper>LICENSES & CERTIFICATIONS</TitleWrapper>
      <Box>
        {/*{Certifications.map((certficate) => (*/}
        {/*  <Certification certficate={certficate} key={certficate.name} />*/}
              {/*))}*/}
              <img width="20%" src={HCMUELogo} alt="university logo" />
              <p style={{ color:"red"}}>Studying in progress at HCMUE. Not graduated yet.</p>
      </Box>
    </SectionWrapper>
  );
};
